import React, { useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import Page from 'src/components/Page'
import PublicCourse from './PublicCourse'
import BoughtCourseDetails from '../boughtCourse/BoughtCourseDetails'
import BoughtCourseSection from '../boughtCourse/BoughtCourseSection'
import BoughtEpisodeVideos from '../boughtCourse/BoughtEpisodeVideos'
import Survey from '../Survey'

function PublicCourses() {
  useEffect(() => {
  }, [])

  return (
    <Page title="دوره های عمومی">
      <Routes>
        <Route path="/" element={<PublicCourse />} />
        <Route path="/course/:id" element={<BoughtCourseDetails bought />} />
        <Route path="/course/:id/section/:id" element={<BoughtCourseSection />} />
        <Route path="/course/:id/section/:id/episode/:id" element={<BoughtEpisodeVideos />} />
        <Route path="/course/survey/:userExamId" element={<Survey />} />
      </Routes>
    </Page>
  )
}

export default PublicCourses
